/* src/app/forms/log-aplicacao/log-aplicacao.component.scss */
.listoffile {
  height: 100%;
}
.view-component-body {
  height: 100% !important;
}
.mat-mdc-card-actions {
  float: right;
}
.toolbar {
  font-size: 16px;
  flex: 1 1 auto;
}
.file {
  font-weight: bold;
}
.label1 {
  padding-right: 12px;
}
.span {
  flex: 1 1 auto;
  font-size: 14px;
  text-align: right;
  padding-right: 12px;
  display: inline-block;
  width: 100%;
  justify-content: center;
}
.content {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
.mat-mdc-form-field {
}
.mat-mdc-form-field .mat-form-field-wrapper {
  padding-bottom: 0;
}
.mat-mdc-form-field .mat-form-field-underline {
  bottom: 0;
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}
/*# sourceMappingURL=log-aplicacao.component.css.map */
